import { get } from '../request';
import { APP_CONFIG } from '../../config';
import type { ProductsStatusResponse } from '../../@types/productsStatus';

export const getProductsStatus = async (): Promise<ProductsStatusResponse> => {
  return await get(`${APP_CONFIG.baseApiUrl}/konto/api/client/products/status`, 'XSRF-TOKEN');
};
